import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BaseHttpService } from '../base-http/base-http.service';
import { TokenService } from '../token/token.service';
import { PersonalDetailsModel } from './models/customer.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerHttpService extends BaseHttpService {
  private readonly httpClient = inject(HttpClient);

  constructor(tokenService: TokenService) {
    super(tokenService);
  }

  getPersonalDetails(): Observable<PersonalDetailsModel> {
    return this.httpClient.get<PersonalDetailsModel>(
      `${this.baseUrl}api/v${this.apiVersion}/PersonalDetails`, 
    { headers: this.customAuthHeaders });
  }
}
